// src/components/forms/FormTextarea/formTextarea.definitions.ts
import clsx from "clsx";

/**
 * Classes CSS para o container do FormTextarea
 */
export function getFormTextareaContainerClasses(className?: string): string {
  return clsx("space-y-1.5", className);
}

/**
 * Classes CSS para o label
 */
export function getFormTextareaLabelClasses(
  required: boolean = false,
  hasError: boolean = false
): string {
  return clsx(
    "block text-xs font-semibold font-montserrat mb-1",
    {
      "text-raro-gray-700": !hasError,
      "text-red-600": hasError,
    },
    required && "after:content-['*'] after:text-red-500 after:ml-1"
  );
}

/**
 * Classes CSS para o textarea
 */
export function getFormTextareaClasses(
  hasError: boolean = false,
  hasIcon: boolean = false,
  resize: "none" | "both" | "horizontal" | "vertical" = "vertical"
): string {
  return clsx(
    // Classes base
    "w-full px-3 py-2 font-montserrat rounded-lg border transition-all duration-200",
    "text-sm placeholder:text-raro-gray-400 focus:outline-none focus:ring-1",
    "min-h-[80px]", // Altura mínima

    // Resize behavior
    {
      "resize-none": resize === "none",
      resize: resize === "both",
      "resize-x": resize === "horizontal",
      "resize-y": resize === "vertical",
    },

    // Padding para ícone
    {
      "pl-9": hasIcon,
    },

    // Estados condicionais
    {
      // Estado normal
      "border-raro-gray-300 focus:border-primary-500 focus:ring-primary-500/20":
        !hasError,

      // Estado de erro
      "border-red-500 focus:border-red-500 focus:ring-red-500/20 bg-red-50":
        hasError,
    }
  );
}

/**
 * Classes CSS para o container do ícone
 */
export function getIconContainerClasses(): string {
  return clsx(
    "absolute top-0 left-0 pl-2.5 pt-2.5",
    "flex items-start pointer-events-none"
  );
}

/**
 * Classes CSS para mensagem de erro
 */
export function getErrorMessageClasses(): string {
  return clsx("text-xs text-red-600 font-montserrat mt-1");
}

/**
 * Classes CSS para texto de ajuda
 */
export function getHelperTextClasses(): string {
  return clsx("text-xs text-raro-gray-500 font-montserrat mt-1");
}

/**
 * Classes CSS para contador de caracteres
 */
export function getCharCountClasses(
  currentCount: number,
  maxCount: number
): string {
  const isNearLimit = currentCount > maxCount * 0.8;
  const isOverLimit = currentCount > maxCount;

  return clsx("text-xs font-montserrat mt-1", {
    "text-raro-gray-500": !isNearLimit,
    "text-amber-600": isNearLimit && !isOverLimit,
    "text-red-600": isOverLimit,
  });
}
